<!--div id="nativo" [innerHTML]="htmlSafe"></div//-->
<span id="teste-popover" class="nonedit spanID" style="pointer-events: auto; background-color: lightgray; border-radius: 12px; padding: 0px 5px; cursor: pointer;" data-user="3a85f726-1bb7-4839-92d0-0ff71b45b40e" (click)="popover()">Genilcia Cunha da Silva</span>
<text-html [html]="html" [analiser]="editorService.bindProfileClick.bind(editorService)"></text-html>
<!--div class="d-block">
    {{ID_GENERATOR_BASE}}
</div!-->

<stacked [series]="serie"></stacked>


<!--button type="button" class="btn btn-primary" (click)="renderTemplate()">Primary</button>

<ng-template #objetivo let-objetivo="objetivo">

</ng-template>
<ng-template #unidade>

</ng-template>
<ng-template #entregas>

</ng-template>
<ng-template #metas>

</ng-template>
<ng-template #atividades>

</ng-template//-->

<!--table class="table okr">
    <thead>
        <tr>
            <th scope="col">O - Objetivo</th>
            <th scope="col">Unidades</th>
            <th scope="col">K - Entregas</th>
            <th scope="col">R - Metas</th>
            <th scope="col">Atividades</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td class="azul" rowspan="4">Ser simples e ágil</td>
            <td class="vermelho" rowspan="3">SETIC-PI</td>
            <td class="verde">Utilizar o Petrvs</td>
            <td class="vazio">Frequentemente</td>
        </tr>
        <tr>
            <td class="rosa">Requisição de servidores</td>
            <td class="vazio">6</td>
        </tr>
        <tr>
            <td class="amarelo">Compra de equipamentos</td>
            <td class="vazio">2000</td>
        </tr>
        <tr>
            <td class="laranja">SUPEX</td>
            <td class="vazio"></td>
            <td class="vazio"></td>
        </tr>
        <tr>
            <td class="roxo" rowspan="3">Otimizar esforços e recursos</td>
            <td class="verde" rowspan="2">DGP</td>
            <td class="vazio"></td>
            <td class="vazio"></td>
        </tr>
        <tr>
            <td class="vazio"></td>
            <td class="vazio"></td>
        </tr>
        <tr>
            <td class="vermelho">DIREX</td>
            <td class="vazio"></td>
            <td class="vazio"></td>
        </tr>
    </tbody>
</table//-->

<!--editable-form [form]="form">
    <div class="d-flex">
        <div class="flex-grow-1">
            <input-select [size]="12" controlName="level" [items]="[]"></input-select>
        </div>
        <div class="btn-group">
            <button *ngIf="true" type="button" class="btn btn-success" data-bs-toggle="tooltip" data-bs-placement="top" title="Adicionar"><i class="bi bi-arrow-bar-up"></i></button>
            <button *ngIf="false" type="button" class="btn btn-primary" data-bs-toggle="tooltip" data-bs-placement="top" title="Salvar"><i class="bi bi-check-circle"></i></button>
            <button *ngIf="false" type="button" class="btn btn-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Cancelar"><i class="bi bi-dash-circle"></i></button>
        </div>
    </div>
    <div class="row">
        <input-level [size]="12" controlName="level" [validate]="validateLevel"></input-level>
    </div>
    < !--div class="row">
        <input-editor controlName="template" [dataset]="dataset"></input-editor>
    </div>
    <div class="row">
        <input-editor controlName="editor" [canEditTemplate]="false" [template]="form.controls.template.value" [datasource]="datasource"></input-editor>
    </div//-- >
</editable-form>
<br><br>
{{form.controls.editor.value || ""}} //-->
<!--map [items]="mapa">
    <strong></strong>
    <table>
        <map-foreach [template]="eixoTemplate">
            <ng-template #eixoTemplate let-eixo="data" let-objetivos="children" let-metadata="metadata" let-level="level">
                <tr>
                    <td><h3>{{eixo.nome}}</h3></td>
                    <td>
                        <table *ngIf="objetivos?.length">
                            <map-foreach [template]="objetivoTemplate" [items]="objetivos" [level]="level">
                                <ng-template #objetivoTemplate let-objetivo="data" let-eixos="children" let-metadata="metadata" let-level="level">
                                    <tr>
                                        <td>{{objetivo.nome}}</td>
                                        <td>
                                            <table *ngIf="eixos?.length">
                                                <map-foreach [template]="eixoTemplate" [items]="eixos" [level]="level+1"></map-foreach>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-template>
                            </map-foreach>
                        </table>
                    </td>
                </tr>
            </ng-template>
        </map-foreach>
    </table>
</map/-->

<!--separator title="Expediente" collapse transparent>
    <calendar-expediente [expediente]="expediente"></calendar-expediente>
</separator>
<div class="row">
    <input-select [size]="2" label="Forma" controlName="forma" [control]="form!.controls.forma" [items]="lookup.DIA_HORA_CORRIDOS_OU_UTEIS"></input-select>
    <input-number number label="Carga" [size]="1" [control]="form!.controls.carga_horaria"></input-number>
    <input-datetime [date]="isHoras() ? undefined : 'true'" [size]="3" label="Início" controlName="data_inicio" [control]="form!.controls.data_inicio"></input-datetime>
    <input-datetime [date]="isHoras() ? undefined : 'true'" [size]="3" label="Fim" controlName="fim" [control]="form!.controls.fim"></input-datetime>
    <input-timer onlyHours label="Tempo" [size]="3" icon="bi bi-clock" controlName="tempo" [control]="form!.controls.tempo"></input-timer>
</div>
<div class="row">
    <input-multiselect controlName="multiselect" label="Feriados" [size]="6" [control]="form!.controls.feriados" [addItemHandle]="addFeriadoHandle.bind(this)">
        <input-number number label="Dia" [size]="2" [control]="form!.controls.dia"></input-number>
        <input-number number label="Mes" [size]="2" [control]="form!.controls.mes"></input-number>
        <input-number number label="Ano" [size]="3" [control]="form!.controls.ano"></input-number>
        <input-text [size]="5" label="Nome" controlName="nome" [control]="form!.controls.nome"></input-text>
    </input-multiselect>
    <input-multiselect controlName="multiselect" label="Afastamentos" [size]="6" [control]="form!.controls.afastamentos" [addItemHandle]="addAfastamentoHandle.bind(this)">
        <input-datetime [size]="4" label="Início" [control]="form!.controls.data_inicio_afastamento"></input-datetime>
        <input-datetime [size]="4" label="Fim" [control]="form!.controls.data_fim_afastamento"></input-datetime>
        <input-text [size]="4" label="Observacao" [control]="form!.controls.observacao"></input-text>
    </input-multiselect>
</div>
<toolbar [buttons]="buttons"></toolbar>
<separator *ngIf="efemerides" title="Cálculos" collapse>
    <calendar-efemerides [efemerides]="efemerides"></calendar-efemerides>
</separator//-->


<!--ckeditor [editor]="Editor" data="<p>Hello, world!</p>"></ckeditor//-->
<!--comment contents="Teste de <b> comentario </b> teste"></comment/-->

<!--gantt [project]="project"></gantt/-->

<!--kanban>
    <swimlane>
        <docker icon="bi bi-hourglass-split" title="Não iniciado" color="border-warning" [cards]="naoIniciadas"></docker>
    </swimlane>
    <swimlane>
        <docker icon="bi bi-pause-circle" title="Pausadas" color="border-danger" [cards]="pausadas"></docker>
        <docker icon="bi bi-play-circle" title="Iniciadas" color="border-info" [cards]="iniciadas"></docker>
    </swimlane>
    <swimlane>
        <docker icon="bi bi-check-circle" title="Concluídas" color="border-primary" [cards]="concluidas"></docker>
    </swimlane>
    <swimlane>
        <docker icon="bi bi-star-half" title="Avaliadas" color="border-success" [cards]="avaliadas"></docker>
    </swimlane>
</kanban/-->

<!--full-calendar [options]="calendarOptions"></full-calendar/-->

<!--editable-form [form]="form">
    <div class="row">
        <input-number currency [size]="4" label="Valor qualquer" controlName="valor"></input-number>
    </div>
</editable-form//-->

<!--progress-bar [value]="35"></progress-bar>
<br><br>
<div class="progress">
<div class="progress-bar progress-bar-striped" role="progressbar" style="width: 10%" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
</div>
<div class="progress">
<div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
</div>
<div class="progress">
<div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
</div>
<div class="progress">
<div class="progress-bar progress-bar-striped bg-warning" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
</div>
<div class="progress">
<div class="progress-bar progress-bar-striped bg-danger" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
</div//-->

<editable-form [form]="form">
    <div class="row">
        <!--input-editor controlName="descricao" [control]="form!.controls.descricao" [mention]="editorService.usuariosMention" [hasToolbar]="false" [height]="20"></input-editor//-->
    </div>
    <!--div class="row">
        <input-color label="Cor" [size]="4" controlName="cor" [control]="form.controls.cor"></input-color>
        <input-display label="Display" [size]="2" controlName="display" [control]="form.controls.display"></input-display>
        <input-switch label="Switch" [size]="2" controlName="switch" [control]="form.controls.switch"></input-switch>
        < !--input-container labelPosition="top" controlName="switch" [control]="form.controls.switch" [disabled]="false" label="Switch" [bold]="false">
        </input-container/-- >
        <input-search label="Search" [size]="4" controlName="search" [control]="form.controls.search" [dao]="usuarioDao" placeholder="Nome e outras coisas"></input-search>
        <input-datetime label="Data e Hora" [size]="4" controlName="datetime" [control]="form.controls.datetime" (change)="dataChange($event)"></input-datetime>
        <input-datetime date label="Data" [size]="4" controlName="datetimedate" [control]="form.controls.datetimedate"></input-datetime>
        <input-datetime time label="Hora" [size]="4" controlName="datetimetime" [control]="form.controls.datetimetime"></input-datetime>
    </div>
    < !--div class="row">
        <input-text [size]="6" label="Campo1" controlName="campo1"></input-text>
        <input-rate [size]="6" label="Avaliação" controlName="rate"></input-rate>
    </div!-- >
    <div clss="row">
        <input-select [size]="3" label="Ícone" controlName="icon" [control]="form!.controls.icon" [items]="lookup.ICONES"></input-select>
        < !--input-multiselect controlName="multiselect" label="MultiSleect" [size]="12" [control]="form!.controls.multiselect" [addItemHandle]="addItemHandle.bind(this)"!-->
    <!--input-text [size]="6" label="Título" controlName="label" [control]="form!.controls.label"></input-text!-->
    <!--input-color [size]="3" label="Cor" controlName="color" [control]="form!.controls.color"></input-color!-->
    <!--/input-multiselect/-- >
    </div>
    <separator></separator>
    < !--div class="row">
        <input-timer label="Tempo" [size]="3" controlName="horas" [control]="form.controls.horas"></input-timer>
    </div>
    <div clss="row">
        <grid [items]="gridItems" [form]="form" editable>
            <columns>
                <column title="Campo1" [template]="column1" [editTemplate]="columnEdit1">
                    <ng-template let-row="row" #column1>
                        <span>{{row["campo1"]}}</span>
                    </ng-template>
                    <ng-template let-row="row" #columnEdit1>
                        <input-text [size]="12" controlName="campo1" [control]="form.controls.campo1"></input-text>
                    </ng-template>
                </column>
                <column type="date" title="Campo2" field="campo2"></column>
                <column type="datetime" title="Campo3" field="campo3"></column>
                <column type="text" title="Campo4" field="campo4"></column>
                <column type="switch" title="Campo5" field="campo5"></column>
                <column type="options"></column>
            </columns>
        </grid>        
    </div/-->
</editable-form>

<!--input type="date" class="form-control">

< !--input-label type="multiselect" [items]="items" label="Selecione alguma coisa" [maxItemWidth]="200" multiselectStyle="rows" [maxListHeight]="150">
    <input-label type="search" [size]="12" placeholder="matrícula ou nome . . ."></input-label>
</input-label/-->

